import React from 'react'
import { useSelector, useMakeSelector } from 'hooks/redux'
import { getIsSimulating } from 'selectors/navigator'
import { makeLogicSetSimulationsSelector } from 'selectors/feature/simulation'
import PropTypes from 'prop-types'
import { StyledQueryOperators, StyledLogicGateSymbol } from './LogicGates.style'

const LogicGates = ({
  finalComplexQueryOperator,
  abComplexQueryOperator,
  cdComplexQueryOperator,
  uri,
  isSelected,
}) => {
  const isSimulating = useSelector(getIsSimulating)
  const { abGateSimulation, cdGateSimulation, finalGateSimulation } =
    useMakeSelector(makeLogicSetSimulationsSelector, { queryUri: uri })

  const describeLogicGates = [
    {
      operator: abComplexQueryOperator,
      simulatedValue: abGateSimulation,
      position: 'intermediate',
      key: 'ab',
    },
    {
      operator: cdComplexQueryOperator,
      simulatedValue: cdGateSimulation,
      position: 'intermediate',
      key: 'cd',
    },
    {
      operator: finalComplexQueryOperator,
      simulatedValue: finalGateSimulation,
      position: 'final',
      key: 'xyz',
    },
  ]

  return (
    <>
      <StyledQueryOperators>
        {describeLogicGates.map((logicGate) => {
          const { position, key, operator, simulatedValue } = logicGate
          return (
            <StyledLogicGateSymbol
              position={position}
              simulatedValue={isSimulating ? simulatedValue : null}
              abGateSimVal={isSimulating ? abGateSimulation : null}
              cdGateSimVal={isSimulating ? cdGateSimulation : null}
              isSimulating={isSimulating}
              type={key}
              operator={operator}
              isSelected={isSelected}
              key={key}
            />
          )
        })}
      </StyledQueryOperators>
    </>
  )
}

LogicGates.propTypes = {
  finalComplexQueryOperator: PropTypes.string,
  abComplexQueryOperator: PropTypes.string,
  cdComplexQueryOperator: PropTypes.string,
  uri: PropTypes.string,
  isSelected: PropTypes.bool,
}

export default LogicGates
